var _excluded = ["isNumeric"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { chakra, forwardRef, useStyles } from '@chakra-ui/system';
import { __DEV__ } from '@chakra-ui/utils';
import React from 'react';
/* -------------------------------------------------------------------------------------------------
 * TableHeaderCell: Th
 * -----------------------------------------------------------------------------------------------*/

export var RTh = forwardRef((_ref, ref) => {
  var {
    isNumeric
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.th, _extends({}, rest, {
    __css: styles.th,
    "data-is-numeric": isNumeric,
    ref: ref
  }));
});

if (__DEV__) {
  RTh.displayName = 'RTh';
}
//# sourceMappingURL=RTh.js.map